// extracted by mini-css-extract-plugin
module.exports = {"LoadError":"ye_a bag_oa bag_a bag_w bag_j bag_q","LoadError__icon":"ye_b bag_sj bag_fg bag_pu","LoadError__message":"ye_c bag_fg bag_qp"};